import { render, staticRenderFns } from "./TabletDebug.vue?vue&type=template&id=407e49d6&scoped=true&"
import script from "./TabletDebug.vue?vue&type=script&lang=js&"
export * from "./TabletDebug.vue?vue&type=script&lang=js&"
import style0 from "./TabletDebug.vue?vue&type=style&index=0&id=407e49d6&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407e49d6",
  null
  
)

export default component.exports